export default __webpack_public_path__ + "media/images/mail-signature-b62a944e4ab72b61102c5260f14547e0.png";